<usimweb-status-bar *ngIf="progress" class="status-bar" [mode]="'indeterminate'"></usimweb-status-bar>

<div class="container-full">
  <div class="d-flex justify-content-end">
    <usimweb-checkbox
      class="checkbox"
      [label]="'Hide duplicates'"
      [checked]="true"
      (onChange)="hideDuplicates($event)"
    ></usimweb-checkbox>
  </div>

  <div class="row no-marign no-gutters">
    <div class="col-md-12 col-xl-6">
      <div class="version-container">
        <div *ngFor="let version_uuid of modelIds; let i = index">
          <usimweb-dropdown
            class="version-menu"
            placeholder="Versions"
            [default]="version_uuid"
            [values]="versions"
            [key]="'uuid'"
            [value]="'name'"
            (selectionChange)="showVersion($event, i)"
          ></usimweb-dropdown>
        </div>
      </div>

      <mat-tab-group *ngIf="compareResult" (selectedTabChange)="tabChanged($event)" class="tab-box">
        <mat-tab label="Results">
          <app-result-plot
            *ngIf="compareResult.results && titles.length > 1"
            [data]="compareResult.results.data"
            [layout]="compareResult.results.layout"
            [id]="modelIds"
            [titles]="titles"
          ></app-result-plot>
        </mat-tab>

        <mat-tab label="Measurements">
          <div class="col">
            <app-measurement-plot
              *ngIf="densityCurves.length > 1"
              [data]="densityCurves"
              materialName="Density"
            ></app-measurement-plot>
            <app-measurement-plot
              *ngIf="viscoCurves.length > 1"
              [data]="viscoCurves"
              materialName="Viscosity"
              [isLog]="true"
            ></app-measurement-plot>
          </div>
        </mat-tab>
        <mat-tab label="Simulation">
          <div style="margin-top: 30px">
            <div class="col-md-12 col-xl-6">
              <div class="result-container">
                <usimweb-dropdown
                  placeholder="Result"
                  [values]="resultTypes"
                  [key]="key"
                  [value]="value"
                  [default]="resultType"
                  width="200px"
                  (selectionChange)="setResult($event)"
                ></usimweb-dropdown>
                <div *ngIf="animationBarOpen"><app-animation-toolbar></app-animation-toolbar></div>
              </div>
            </div>

            <div *ngIf="loadViewer">
              <div *ngFor="let id of modelIds; let i = index">
                <ceetron-viewer style="margin-left: 30px" [modelId]="numberToString(i)"></ceetron-viewer>
                <app-info [title]="titles[i]" [date]="dates[i]"></app-info>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <div class="col-md-12 col-xl-6">
      <div *ngIf="compareResult" class="scroll-bar">
        <div *ngIf="compareResult.parameters && compareResult.parameters.length > 1">
          <app-parameters
            [versions]="modelIds"
            [project_uuid]="project_uuid"
            [parameters]="compareResult.parameters"
            [titles]="titles"
            #parameter
          ></app-parameters>
        </div>
      </div>
    </div>
  </div>
</div>
